import { execOnLoad } from '@general/helpers';
import './legal-page.scss';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initLegalPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const submit = sectionContainer.querySelector('[type="submit"]');
  sectionContainer.querySelectorAll('input, textarea').forEach((input) => {
    const formElement = input.closest('.form-element');
    if (!formElement) return;

    input.addEventListener('invalid', (e) => {
      e.preventDefault();
      formElement.classList.add('error');
      if (submit) submit.disabled = true;
    });

    input.addEventListener('change', () => {
      formElement.classList.remove('error');
      const errorElements = sectionContainer.querySelectorAll(
        '.form-element.error',
      ).length;
      if (submit && errorElements === 0) submit.disabled = false;
    });
  });

  const navigation = sectionContainer.querySelector(
    'details.legal-page__navigation',
  );
  if (navigation) {
    const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
    const handleNavigation = () => {
      navigation.open = lgUp.matches;
    };
    handleNavigation();
    lgUp.addEventListener('change', handleNavigation);
  }
};

execOnLoad(window.dAgency.initLegalPage, '.legal-page__section');
